import ControlledTable from "@/components/controlled-table";
import { useTableServer } from "@/hooks/useTableServer";
import EnquiryEntriesRepository from "@/utilities/repositories/EnquiryEntries";
import * as React from "react";
import { getLogActionColumns } from "./columns";

export interface LogActionTableProps {
  tableDataPushParams?: boolean;
  submissionId?: string;
}

export interface LogActionTableRef {
  refresh: () => Promise<void>;
}

function LogActionTable(
  { tableDataPushParams = true, submissionId }: LogActionTableProps,
  ref: React.Ref<LogActionTableRef>,
) {
  const {
    isLoading,
    tableData,
    currentPage,
    totalItems,
    handlePaginate,
    pageSize,
    handleChangePageSize,
    sortConfig,
    handleSort,
    refresh,
  } = useTableServer({
    server: {
      request: async (args: any) =>
        EnquiryEntriesRepository.getLogActions(args, submissionId),
    },
    searchBy: (searchTerm) => {
      const s = searchTerm || undefined;
      return {
        search: s,
      };
    },

    pushSearchParams: tableDataPushParams,
  });

  const columns = getLogActionColumns({
    data: tableData,
    onHeaderCellClick: handleSort,
    sortConfig,
  });

  React.useImperativeHandle(
    ref,
    () => ({
      refresh,
    }),
    [refresh],
  );

  // Auto-refresh when submissionId changes to ensure activity history
  // is updated for the selected card/lead
  React.useEffect(() => {
    if (submissionId) {
      refresh();
    }
  }, [submissionId]);

  return (
    <ControlledTable
      variant="modern"
      data={tableData}
      isLoading={isLoading}
      showLoadingText={true}
      columns={columns}
      paginatorOptions={{
        pageSize,
        setPageSize: handleChangePageSize,
        total: totalItems,
        current: currentPage,
        onChange: (page: number) => handlePaginate(page),
      }}
      className="rounded-md border border-muted text-sm shadow-sm [&_.rc-table-placeholder_.rc-table-expanded-row-fixed>div]:h-60 [&_.rc-table-placeholder_.rc-table-expanded-row-fixed>div]:justify-center [&_.rc-table-row:last-child_td.rc-table-cell]:border-b-0 [&_thead.rc-table-thead]:border-t-0"
    />
  );
}

LogActionTable.displayName = "LogActionTable";
export default React.memo(React.forwardRef(LogActionTable));
